import { Sms } from '@mui/icons-material';

export const SmsIconMUI = Sms;
